import React from "react";
import { Icon } from "./Icon";
import { Link } from "react-router-dom";
import { PageMeta } from "./PageMeta";

const PrivacyPolicy: React.FC = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#0a0a0a",
        padding: "40px 20px",
        width: "100%",
      }}
    >
      <PageMeta
        title="Privacy Policy — HAL 8580"
        description="How HAL 8580 collects, stores, and protects data for streamers and their viewers — what we keep, why we keep it, and what we never do with it."
        path="/privacy"
        breadcrumbs={[{ name: "Privacy Policy" }]}
      />
      <div
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          backgroundColor: "#1a1f2e",
          borderRadius: "12px",
          padding: "40px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.3)",
        }}
      >
        <Link
          to="/dashboard"
          style={{
            color: "#9146FF",
            textDecoration: "none",
            fontSize: "14px",
            display: "inline-block",
            marginBottom: "20px",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = "#a855f7";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = "#9146FF";
          }}
        >
          <Icon
            name="arrow-left"
            size={14}
            style={{ verticalAlign: "-2px", marginRight: "6px" }}
          />
          Back to Dashboard
        </Link>

        <h1 style={{ color: "#ffffff", marginBottom: "10px" }}>
          Privacy Policy
        </h1>
        <p style={{ color: "#cbd5e0", marginBottom: "30px", fontSize: "14px" }}>
          Last updated: January 2025
        </p>

        <div style={{ color: "#cbd5e0", lineHeight: "1.8" }}>
          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                color: "#ffffff",
                marginBottom: "15px",
                fontSize: "20px",
              }}
            >
              1. Information We Collect
            </h2>
            <p style={{ marginBottom: "15px" }}>
              When you use HAL 8580 (&quot;the Service&quot;), we collect the
              following information:
            </p>
            <ul style={{ marginLeft: "20px", marginBottom: "15px" }}>
              <li style={{ marginBottom: "10px" }}>
                <strong>Twitch Account Information:</strong> Your Twitch
                username, user ID, email address, and profile information when
                you authenticate with Twitch.
              </li>
              <li style={{ marginBottom: "10px" }}>
                <strong>Channel Data:</strong> Information about your Twitch
                channel, including stream titles, categories, viewer counts, and
                stream schedules.
              </li>
              <li style={{ marginBottom: "10px" }}>
                <strong>Chat Messages:</strong> Public chat messages from your
                Twitch channel for bot functionality and context awareness.
              </li>
              <li style={{ marginBottom: "10px" }}>
                <strong>Bot Configuration:</strong> Your bot settings, custom
                keywords, personality preferences, and custom context
                information.
              </li>
              <li style={{ marginBottom: "10px" }}>
                <strong>Usage Data:</strong> Information about how you interact
                with the Service, including feature usage and bot performance
                metrics.
              </li>
            </ul>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                color: "#ffffff",
                marginBottom: "15px",
                fontSize: "20px",
              }}
            >
              2. How We Use Your Information
            </h2>
            <p style={{ marginBottom: "15px" }}>
              We use the collected information to:
            </p>
            <ul style={{ marginLeft: "20px", marginBottom: "15px" }}>
              <li style={{ marginBottom: "10px" }}>
                Provide and operate the HAL 8580 bot service
              </li>
              <li style={{ marginBottom: "10px" }}>
                Authenticate your identity and manage your account
              </li>
              <li style={{ marginBottom: "10px" }}>
                Generate contextually aware bot responses using AI
              </li>
              <li style={{ marginBottom: "10px" }}>
                Remember user interactions and build conversation history
              </li>
              <li style={{ marginBottom: "10px" }}>
                Improve and optimize the Service
              </li>
              <li style={{ marginBottom: "10px" }}>
                Communicate with you about service updates and support
              </li>
            </ul>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                color: "#ffffff",
                marginBottom: "15px",
                fontSize: "20px",
              }}
            >
              3. Data Storage and Security
            </h2>
            <p style={{ marginBottom: "15px" }}>
              Your data is stored securely using industry-standard encryption
              and security practices:
            </p>
            <ul style={{ marginLeft: "20px", marginBottom: "15px" }}>
              <li style={{ marginBottom: "10px" }}>
                All data is encrypted in transit using HTTPS
              </li>
              <li style={{ marginBottom: "10px" }}>
                Database access is restricted and secured
              </li>
              <li style={{ marginBottom: "10px" }}>
                Authentication tokens are securely stored and regularly
                refreshed
              </li>
            </ul>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                color: "#ffffff",
                marginBottom: "15px",
                fontSize: "20px",
              }}
            >
              4. Third-Party Services
            </h2>
            <p style={{ marginBottom: "15px" }}>
              We integrate with the following third-party services:
            </p>
            <ul style={{ marginLeft: "20px", marginBottom: "15px" }}>
              <li style={{ marginBottom: "10px" }}>
                <strong>Twitch:</strong> For authentication and channel data
                access
              </li>
              <li style={{ marginBottom: "10px" }}>
                <strong>OpenAI:</strong> For generating AI-powered bot responses
              </li>
            </ul>
            <p style={{ marginBottom: "15px" }}>
              Each of these services has their own privacy policies and data
              handling practices.
            </p>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                color: "#ffffff",
                marginBottom: "15px",
                fontSize: "20px",
              }}
            >
              5. Data Retention
            </h2>
            <p style={{ marginBottom: "15px" }}>
              We retain your data as follows:
            </p>
            <ul style={{ marginLeft: "20px", marginBottom: "15px" }}>
              <li style={{ marginBottom: "10px" }}>
                Chat messages: 30 days for active context, then archived
              </li>
              <li style={{ marginBottom: "10px" }}>
                User memories and knowledge base: Retained while account is
                active
              </li>
              <li style={{ marginBottom: "10px" }}>
                Account information: Retained until account deletion is
                requested
              </li>
            </ul>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                color: "#ffffff",
                marginBottom: "15px",
                fontSize: "20px",
              }}
            >
              6. Your Rights
            </h2>
            <p style={{ marginBottom: "15px" }}>You have the right to:</p>
            <ul style={{ marginLeft: "20px", marginBottom: "15px" }}>
              <li style={{ marginBottom: "10px" }}>
                Access your personal data
              </li>
              <li style={{ marginBottom: "10px" }}>
                Request correction of inaccurate data
              </li>
              <li style={{ marginBottom: "10px" }}>
                Request deletion of your data
              </li>
              <li style={{ marginBottom: "10px" }}>
                Export your data in a portable format
              </li>
              <li style={{ marginBottom: "10px" }}>
                Opt-out of certain data processing activities
              </li>
            </ul>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                color: "#ffffff",
                marginBottom: "15px",
                fontSize: "20px",
              }}
            >
              7. Children&apos;s Privacy
            </h2>
            <p style={{ marginBottom: "15px" }}>
              The Service is not intended for users under 13 years of age. We do
              not knowingly collect personal information from children under 13.
            </p>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                color: "#ffffff",
                marginBottom: "15px",
                fontSize: "20px",
              }}
            >
              8. Changes to This Policy
            </h2>
            <p style={{ marginBottom: "15px" }}>
              We may update this Privacy Policy from time to time. We will
              notify you of any changes by posting the new Privacy Policy on
              this page and updating the &quot;Last updated&quot; date.
            </p>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                color: "#ffffff",
                marginBottom: "15px",
                fontSize: "20px",
              }}
            >
              9. Contact Us
            </h2>
            <p style={{ marginBottom: "15px" }}>
              If you have questions about this Privacy Policy, please visit our{" "}
              <Link
                to="/support"
                style={{ color: "#9146FF", textDecoration: "none" }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = "#a855f7";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = "#9146FF";
                }}
              >
                Support page
              </Link>
              .
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
